import ReactOnRails from 'react-on-rails';

import Registration from '../general/registration/Main';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  Registration,
});
